export const hasClubs = (clubs) => {
  let response = false;
  if (clubs.data) {
    const clubsArr = Object.keys(clubs.data);
    response = clubsArr.length > 0 || false;
  }
  return response;
};

export const hasLoyalty = (settings) => {
  if (
    settings.data?.loyalty?.hasLoyalty &&
    settings.data?.loyalty?.status === 'Active'
  ) {
    return true;
  }
  return false;
};

export const hasReservations = (reservationTypes) => {
  let response = false;
  if (reservationTypes.data) {
    const reservationTypesArr = Object.keys(reservationTypes.data);
    response = reservationTypesArr.length > 0 || false;
  }
  return response;
};
